import React from 'react';
import { addCommas, removeNonNumeric } from '@helper';
const AmountInput = ({ value, onChange, ...restProps }) => {
    return (
        <input
            value={addCommas(removeNonNumeric(value))}
            onChange={onChange}
            {...restProps}
        />
    );
};

export default AmountInput;
